import { Section } from "@models/ISchema";
import { getPastSessionIds } from "./getPastSessionIds";

export interface SectionPastSessions {
  pastSessionIds: string[];
  hasPastAndActiveSessions: boolean;
}

export const getSectionPastSessions = (
  section: Section,
  thresholdDate: string | null,
  canEditPastSessions: boolean,
): SectionPastSessions => {
  const pastSessionIds = getPastSessionIds(section, thresholdDate, canEditPastSessions);

  const totalSessions =
    (section?.sessions?.length ?? 0) + (section?.unasignedSessions?.length ?? 0);

  return {
    pastSessionIds,
    hasPastAndActiveSessions: pastSessionIds.length > 0 && pastSessionIds.length < totalSessions,
  };
};
